export const SET_ERROR = 'user/SET_ERROR';
export const CLEAR_ERROR = 'user/CLEAR_ERROR';
export const REQUEST_STARTED = 'user/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'user/REQUEST_SUCCESSFUL';
export const SET_USER = 'user/SET_USER';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});
